/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { NumericFormat } from 'react-number-format';

/* Helpers, constants, custom methods, internal libraries */
import { getCurrencySymbol } from "../../../helpers/general";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as AssignUser } from '../../../resources/images/user-plus-02.svg';

/* Styles */
import styles from "./styles";

const TravelCreditsAssignModal = ({ showTravelCreditsAssignModal, setShowTravelCreditsAssignModal, userDetails, selectedRow, submitCallback }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const [assignCreditsStep, setAssignCreditsStep] = useState(0);
  const [removableChip, setRemovableChip] = useState({});

  useEffect(() => {
    if (!showTravelCreditsAssignModal) {
      setAssignCreditsStep(0)
    }
  }, [showTravelCreditsAssignModal])

  const handleContinue = async () => {
    if (assignCreditsStep === 0) {
      setAssignCreditsStep(1)
    } else {
      const idsArray = []
      idsArray.push(removableChip.userEntityId);
      const groupData = {
        requestBody: {
          ids: idsArray,
          fopId: selectedRow.fopId
        }
      }
      submitCallback(groupData, setShowTravelCreditsAssignModal)
    }
  }

  return (
      <UCModal
        className={classes.travelCreditsAssignModal}
        showModal={ showTravelCreditsAssignModal }
        setShowModal={ setShowTravelCreditsAssignModal }
        modalIcon={ <AssignUser /> }
        modalTitle={ assignCreditsStep === 0 ?
          selectedRow &&
          <NumericFormat
              value={selectedRow?.value}
              thousandSeparator=","
              decimalScale={2}
              fixedDecimalScale
              displayType="text"
              prefix={getCurrencySymbol(selectedRow?.currency)}
              renderText={(value) => <div>{value} {selectedRow?.currency}</div>}
          />
              : 
          <FormattedMessage id="travelCredits.assign.modal.confirm.title" />}
        modalDescription={ assignCreditsStep === 0 ? 
          <FormattedMessage id="travelCredits.assign.modal.assign.credit.number" values={{number: `#${selectedRow?.number}`}}/> 
              : 
          <FormattedMessage id="travelCredits.assign.modal.confirm.assign.number" values={{number: `#${selectedRow?.number}`}}/>}
        modalContent={ 
            <Content 
              setShowTravelCreditsAssignModal={setShowTravelCreditsAssignModal} 
              showTravelCreditsAssignModal={showTravelCreditsAssignModal}
              assignCreditsStep={assignCreditsStep} 
              handleContinue={handleContinue} 
              setAssignCreditsStep={setAssignCreditsStep}
              userDetails={userDetails}
              removableChip={removableChip}
              setRemovableChip={setRemovableChip}
            /> 
          }
          //todo: test cahnges before merge!!!
        dataTestId="travelCreditsAssignModal"
      />
  )
}

export default TravelCreditsAssignModal;